import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    bgimg: {
        backgroundImage: "url('https://images.unsplash.com/photo-1588385623903-854503680854?crop=entropy&cs=tinysrgb&fit=crop&fm=jpg&h=900&ixid=eyJhcHBfaWQiOjF9&ixlib=rb-1.2.1&q=80&w=1600')",
        height: '100%',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        position: 'relative',
        color: 'white',
        fontFamily: '"Courier New", Courier, monospace',
        fontSize: '25px'
    },
    topleft: {
        position: 'absolute',
        top: '0',
        left: '16px'
    },
    bottomleft: {
        position: 'absolute',
        bottom: '0',
        left: '16px'
    },
    middle: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center'
    },
    hr: {
        margin: 'auto',
        width: '40%'
    }
}));

export default function ComingSoon() {
    const location = useLocation();
    const classes = useStyles();
    const [customMessage] = React.useState(location.state.customMessage);

    return (
        <div className={classes.bgimg}>
            <div className={classes.topleft}>
                <p>Getz</p>
            </div>
            <div className={classes.middle}>
                <h1>{customMessage}</h1>
                <hr className={classes.hr} />
            </div>
            <div className={classes.bottomleft}>
                <p>Getz</p>
            </div>
        </div>
    )
}